var _path, _circle, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpPro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 861,
    height: 744,
    viewBox: "0 0 861 744",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.76 29.899C419.436 16.5861 438.635 16.5447 446.369 29.8245L508.213 136.02C511.81 142.195 511.838 149.821 508.287 156.023L278.667 557.062C271.032 570.396 280.659 587 296.023 587H761.283C768.519 587 775.191 590.909 778.729 597.221L844.309 714.221C851.781 727.553 842.145 744 826.862 744H34.6189C19.2278 744 9.60469 727.343 17.2929 714.01L411.76 29.899Z",
    fill: "#0E375A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 603,
    cy: 578,
    r: 65,
    fill: "#34AAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_302_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520.679 208C528.377 194.667 547.623 194.667 555.321 208L693.885 448C701.583 461.333 691.96 478 676.564 478H399.436C384.04 478 374.417 461.333 382.115 448L520.679 208Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M521.244 208.684C529.041 195.456 548.219 195.584 555.838 208.915L612.129 307.401C615.75 313.736 615.634 321.54 611.826 327.764L474.36 552.438C470.726 558.378 464.264 562 457.3 562H348.003C332.527 562 322.915 545.177 330.774 531.845L521.244 208.684Z",
    fill: "#ED8254"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_302_3",
    x: 375.406,
    y: 198,
    width: 325.188,
    height: 288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_302_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_302_3",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpPro);
export default __webpack_public_path__ + "static/media/lp_pro.202e3c54139edf56ce98275476a9f7b2.svg";
export { ForwardRef as ReactComponent };